import { useState, useEffect } from 'react'

interface MobileBreakpoints {
  mobile: number
  tablet: number
  desktop: number
}

const defaultBreakpoints: MobileBreakpoints = {
  mobile: 640,
  tablet: 1024,
  desktop: 1280
}

export function useMobileResponsive(breakpoints = defaultBreakpoints) {
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 1024,
    height: typeof window !== 'undefined' ? window.innerHeight : 768
  })

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      })
    }

    window.addEventListener('resize', handleResize)
    handleResize() // Initial call

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const isMobile = windowSize.width < breakpoints.mobile
  const isTablet = windowSize.width >= breakpoints.mobile && windowSize.width < breakpoints.tablet
  const isDesktop = windowSize.width >= breakpoints.desktop
  const isLaptop = windowSize.width >= breakpoints.tablet && windowSize.width < breakpoints.desktop

  return {
    windowSize,
    isMobile,
    isTablet,
    isLaptop,
    isDesktop,
    breakpoints
  }
}

export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    const media = window.matchMedia(query)
    if (media.matches !== matches) {
      setMatches(media.matches)
    }

    const listener = () => setMatches(media.matches)
    media.addEventListener('change', listener)

    return () => media.removeEventListener('change', listener)
  }, [matches, query])

  return matches
}